import { RouteConfig } from 'vue-router';
import Layout from '@/layout/index.vue';

const configRouter: RouteConfig = {
  // name: 'Config',
  path: '/config',
  component: Layout,
  meta: {
    title: 'route.config',
    icon: 'iconshezhi1',
    activeMenu: ['/config'],
    alwaysShow: false,
  },
  children: [
    {
      path: '/config/quotation',
      name: 'Quotation',
      component: () => import('@/views/config/quotation/index.vue'),
      meta: {
        title: 'route.quotation',
        permissions: ['QuotationCategory_CreateUpdate'],
        activeMenu: ['/config', '/config/quotation'],
        breadcrumb: [
          {title: 'route.quotation', path: '/config/quotation'},
        ],
      },
    },
    {
      path: '/config/role',
      name: 'Role',
      component: () => import('@/views/config/role/index.vue'),
      meta: {
        title: 'route.role',
        permissions: ['Role_Create', 'Role_Edit_All', 'Role_Edit_Own'],
        activeMenu: ['/config', '/config/role'],
        breadcrumb: [
          {title: 'route.role', path: '/config/role'},
        ],
      },
    },
    {
      path: '/config/user',
      name: 'User',
      component: () => import('@/views/config/user/index.vue'),
      meta: {
        title: 'route.user',
        permissions: ['User_CreateUpdate'],
        activeMenu: ['/config', '/config/user'],
        breadcrumb: [
          {title: 'route.user', path: '/config/user'},
        ],
      },
    },
    {
      path: '/config/project',
      name: 'Project',
      component: () => import('@/views/config/project/index.vue'),
      meta: {
        title: 'route.project',
        permissions: ['Project_Create', 'Project_Edit_Own', 'Project_Edit_Admin', 'Project_Edit_All'],
        activeMenu: ['/config', '/config/project'],
        breadcrumb: [
          {title: 'route.project', path: '/config/project'},
        ],
      },
    },
    {
      path: '/config/team',
      name: 'Team',
      component: () => import('@/views/config/team/index.vue'),
      meta: {
        title: 'route.team',
        permissions: ['Team_Create', 'Team_Edit_All', 'Team_Edit_Admin', 'Team_Edit_Leader', 'Team_Edit_Own'],
        activeMenu: ['/config', '/config/team'],
        breadcrumb: [
          {title: 'route.team', path: '/config/team'},
        ],
      },
    },
    {
      path: '/config/permission',
      name: 'Permission',
      component: () => import('@/views/config/permission/index.vue'),
      meta: {
        title: 'route.permission',
        permissions: ['User_CreateUpdate', 'Role_Edit_All'],
        activeMenu: ['/config', '/config/permission'],
        breadcrumb: [
          {title: 'route.permission', path: '/config/permission'},
        ],
      },
    },
    {
      path: '/config/label',
      name: 'Label',
      component: () => import('@/views/config/label/index.vue'),
      meta: {
        title: 'route.label',
        permissions: ['Label_CreateUpdate'],
        activeMenu: ['/config', '/config/label'],
        breadcrumb: [
          {title: 'route.label', path: '/config/label'},
        ],
      },
    },
    {
      path: '/config/todoType',
      name: 'TodoType',
      component: () => import('@/views/config/todoType/index.vue'),
      meta: {
        title: 'route.todoType',
        permissions: ['TodoType_CreateUpdate'],
        activeMenu: ['/config', '/config/todoType'],
        breadcrumb: [
          {title: 'route.todoType', path: '/config/todoType'},
        ],
      },
    },
    {
      path: '/config/settlementUnit',
      name: 'SettlementUnit',
      component: () => import('@/views/config/settlementUnit/index.vue'),
      meta: {
        title: 'route.settlementUnit',
        activeMenu: ['/config', '/config/settlementUnit'],
        permissions: ['SettlementUnit_CreateUpdate'],
        breadcrumb: [
          {title: 'route.settlementUnit', path: '/config/settlementUnit'},
        ],
      },
    },
  ],
};

export default configRouter;
